export default {"src":"/_next/static/media/atlas.3372db59.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};